const AUTH_REDIRECT_KEY = "zeaMaysAuthRedirect";

export const saveAuthRedirectPath = (path) => {
  if (!path) {
    return;
  }

  sessionStorage.setItem(AUTH_REDIRECT_KEY, path);
};

export const readAuthRedirectPath = () => {
  return sessionStorage.getItem(AUTH_REDIRECT_KEY) || "";
};

export const clearAuthRedirectPath = () => {
  sessionStorage.removeItem(AUTH_REDIRECT_KEY);
};
